module.exports = __webpack_public_path__ + "img/img_kuangxuan.ec71d466.png";